import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';

export const TeamDialog = ({ open, onOpenChange, selectedTeam, teamForm, setTeamForm, tournament, coaches, onSave }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{selectedTeam ? 'Edit Team' : 'Create New Team'}</DialogTitle>
        <DialogDescription>{selectedTeam ? 'Update team details' : 'Add a new team to this tournament'}</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div>
          <Label>Team Name</Label>
          <Input value={teamForm.name} onChange={(e) => setTeamForm({ ...teamForm, name: e.target.value })} placeholder="e.g., U11 Team A" data-testid="team-name-input" />
        </div>
        <div>
          <Label>Age Category <span className="text-slate-400 font-normal">(optional)</span></Label>
          <Select value={teamForm.age_category || 'none'} onValueChange={(value) => setTeamForm({ ...teamForm, age_category: value === 'none' ? '' : value })}>
            <SelectTrigger data-testid="team-age-category-select"><SelectValue placeholder="No age category" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">No age category</SelectItem>
              {tournament?.age_categories?.map(cat => (<SelectItem key={cat} value={cat}>{cat.toUpperCase()}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
        {tournament?.is_division_based && tournament?.divisions?.length > 0 && (
          <div>
            <Label>Division</Label>
            <Select value={teamForm.division} onValueChange={(value) => setTeamForm({ ...teamForm, division: value })}>
              <SelectTrigger data-testid="team-division-select"><SelectValue placeholder="Select division" /></SelectTrigger>
              <SelectContent>
                {tournament.divisions.map(div => (<SelectItem key={div} value={div}>{div}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
        )}
        <div>
          <Label>Coach (Optional)</Label>
          <Select value={teamForm.coach_id || 'none'} onValueChange={(value) => setTeamForm({ ...teamForm, coach_id: value === 'none' ? '' : value })}>
            <SelectTrigger data-testid="team-coach-select"><SelectValue placeholder="Select a coach" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">No coach assigned</SelectItem>
              {coaches.map(coach => (<SelectItem key={coach.id} value={coach.id}>{coach.display_name || coach.name}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>CricClubs Schedule URL (Optional)</Label>
          <Input placeholder="https://cricclubs.com/..." value={teamForm.cricclubs_url} onChange={(e) => setTeamForm({ ...teamForm, cricclubs_url: e.target.value })} data-testid="team-cricclubs-url" />
          <p className="text-xs text-slate-500 mt-1">Link to the team's schedule on CricClubs</p>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onSave} data-testid="save-team-btn">{selectedTeam ? 'Update Team' : 'Create Team'}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
